import { router } from "../../app/router/Routes";

import { Edit, Schema } from "@mui/icons-material";
import { Card, CardActions, CardContent, CardHeader, Grid, IconButton, Typography } from "@mui/material";
import { Board } from "../../app/models/board";

interface Params {
    board: Board
    setSelectedBoard: (board: Board) => void
}

function BoardCard({ board, setSelectedBoard }: Params) {

    const navigateToBoardsGraph = () => {
        setSelectedBoard(board)
        router.navigate('/graphEditor')
    }

    return (
        <Card sx={{
            height: "100%",
            width: 400,
            display: "flex",
            flexDirection: "column",
        }}>
            <CardHeader
                title={board.title}
            />
            <CardContent>
                <Typography variant="body2" color="text.secondary">
                    {board.description}
                </Typography>
            </CardContent>
            <CardActions disableSpacing sx={{ mt: "auto" }}>
                <Grid container justifyContent='space-between'>
                    <IconButton aria-label="add to favorites" onClick={() => navigateToBoardsGraph()}>
                        <Schema />
                    </IconButton>
                    {
                        !board.readonly &&
                        <IconButton aria-label="share" onClick={() => router.navigate(`boards/${board.id}`)}>
                            <Edit/>
                        </IconButton>
                    }
                </Grid>
            </CardActions>
        </Card>
    );
}

export default BoardCard;